import React, { useEffect } from "react";
import useEventStore from "../stores/EventStore";
import './EventDate.css';

export default function EventVoteAdminPage() {
    const { voteCountParticipateWithName, getEventVoteParticipateWithName } = useEventStore();

    useEffect(() => {
        //methode
        getEventVoteParticipateWithName();
        const interval = setInterval(async () => {
            try {
                //methode
                getEventVoteParticipateWithName();
            } catch (error) {
                console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
            }
        }, 5000); // polls every 5 seconds
        return () => clearInterval(interval);
    }, []);


    // Group by voteDate instead of eventDateId
    const groupedVotes = {};

    voteCountParticipateWithName.forEach(({ voteDate, username, voteValue }) => {
        if (!groupedVotes[voteDate]) {
            groupedVotes[voteDate] = { yes: [], no: [] };
        }
        if (voteValue === 1) {
            groupedVotes[voteDate].yes.push(username);
        } else if (voteValue === 0) {
            groupedVotes[voteDate].no.push(username);
        }
    });


    return (
        <div className="admin-container">
            <div className="admin-container">
                <h2>Abstimmungsergebnisse</h2>
                <div className="overflow-x-auto">
                    <table className="attendance-table">
                        <thead>
                            <tr>
                                <th>Nimmt teil</th>
                                <th>Nimmt nicht teil</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedVotes).map(([voteDate, votes]) => (
                                <tr key={voteDate}>
                                    <td>{votes.yes.length > 0 ? votes.yes.map((name, idx) => <div key={idx}>{name}</div>) : "—"}</td>
                                    <td>{votes.no.length > 0 ? votes.no.map((name, idx) => <div key={idx}>{name}</div>) : "—"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
